import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconCloseSmall({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M5.941.766 4 2.708 2.059.766A.918.918 0 0 0 .769.77a.91.91 0 0 0-.003 1.29L2.708 4 .766 5.941a.918.918 0 0 0 .003 1.29.91.91 0 0 0 1.29.003L4 5.292l1.941 1.942a.918.918 0 0 0 1.29-.003.91.91 0 0 0 .003-1.29L5.292 4l1.942-1.941A.918.918 0 0 0 7.23.769.91.91 0 0 0 5.94.766z"/>
        </svg>
    );
}

export default IconCloseSmall;
